import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
    de: {
        // Navigation
        dashboard: 'Dashboard',
        meta: 'Meta',
        relics: 'Relics',
        accessories: 'Accessories',
        skills: 'Skills',
        gachas: 'Gachas',
        upgrades: 'Upgrades',
        achievements: 'Achievements',
        tutorials: 'Tutorials',
        timers: 'Timer',
        admin: 'Admin',
        adminPanel: 'Admin Panel',
        reports: 'Meldungen',
        logout: 'Abmelden',
        
        // Dashboard
        yourProgress: 'Dein persönlicher Fortschritt und Statistiken',
        overallProgress: 'Gesamtfortschritt',
        progressDescription: 'Dein Sammelfortschritt über alle Kategorien',
        collected: 'gesammelt',
        compareItems: 'Items vergleichen',
        patchNotes: 'Patch Notes',
        ourTeam: 'Unser Team',
        noPatchNotes: 'Keine Patch Notes vorhanden.',
        noTeamMembers: 'Keine Teammitglieder vorhanden.',
        exportProgress: 'Fortschritt exportieren',
        
        // Timer Page
        eventSchedules: 'Event Zeitpläne',
        eventSchedulesDescription: 'Respawn-Zeiten und Event-Countdowns (UTC)',
        nextEvent: 'Nächstes Event',
        active: 'Aktiv',
        startsIn: 'Startet in',
        endsIn: 'Endet in',
        monToThu: 'Montag bis Donnerstag',
        friToSun: 'Freitag bis Sonntag',
        everyDay: 'Jeden Tag',
        spawnRate: 'Spawn Rate',
        despawns: 'Despawnt nach',
        minutes: 'Minuten',
        lasts: 'Dauert',
        inGameTime: 'Spielzeit',
        
        // Admin
        wikiContent: 'Wiki Inhalte',
        islandSystem: 'Insel-System',
        management: 'Verwaltung',
        metaBuilds: 'Meta Builds',
        dataBackup: 'Daten-Backup',
        changeHistory: 'Änderungsverlauf',
        team: 'Team',
        searchEntries: 'Einträge durchsuchen...',
        newEntry: 'Neuer Eintrag',
        lock: 'Sperren',
        unlock: 'Entsperren',
        loading: 'Laden...',
        noEntries: 'Keine Einträge gefunden',
        noDescription: 'Keine Beschreibung',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        save: 'Speichern',
        cancel: 'Abbrechen',
        create: 'Erstellen',
        name: 'Name',
        description: 'Beschreibung',
        image: 'Bild',
        rarity: 'Seltenheit',
        selectIsland: 'Wähle eine Insel',
        newGacha: 'Neues Gacha',
        newUpgrade: 'Neues Upgrade',
        selectIslandToManage: 'Wähle eine Insel aus, um Items zu verwalten',
        valuesPerRarity: 'Werte nach Seltenheit',
        addField: 'Feld hinzufügen',
        fieldName: 'Feldname',
        value: 'Wert',
        noValues: 'Keine Werte definiert',
        confirmDelete: 'Wirklich löschen?',
        deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
        templates: 'Vorlagen',
        useTemplate: 'Vorlage verwenden',
        saveAsTemplate: 'Als Vorlage speichern',
        duplicateWarning: 'Ein Eintrag mit ähnlichem Namen existiert bereits!',
        whitelist: 'Whitelist',
        
        // Sperrmodus
        lockMode: 'Sperrmodus',
        lockModeDescription: 'Sperre einzelne Bereiche der Seite. Gesperrte Seiten werden als "In Entwicklung" angezeigt.',
        locked: 'Gesperrt',
        unlocked: 'Entsperrt',
        lockStatusChanged: 'Sperrstatus geändert',
        lockError: 'Fehler beim Ändern des Sperrstatus',
        
        // Admin descriptions
        adminDescRelics: 'Verwalte Wiki-Einträge für Relics',
        adminDescAccessories: 'Verwalte Wiki-Einträge für Accessories',
        adminDescSkills: 'Verwalte Wiki-Einträge für Skills',
        adminDescGachas: 'Wähle eine Insel und verwalte deren Gachas',
        adminDescUpgrades: 'Wähle eine Insel und verwalte deren Upgrades',
        adminDescAchievements: 'Verwalte Achievements und Belohnungen',
        adminDescTutorials: 'Verwalte Tutorial-Einträge',
        adminDescWhitelist: 'Verwalte Discord-Whitelist für den Login',
        adminDescMetaBuilds: 'Verwalte Meta Build Empfehlungen',
        adminDescDataBackup: 'Exportiere, importiere und stelle Daten wieder her',
        adminDescChangeHistory: 'Alle Admin-Aktionen mit Name und Uhrzeit',
        adminDescPatchNotes: 'Verwalte Patch Notes und Updates',
        adminDescTeam: 'Verwalte Teammitglieder',
        adminDescReports: 'Überprüfe gemeldete Probleme',
        adminDescLockMode: 'Sperre einzelne Bereiche der Website',
        searchPatchNotes: 'Patch Notes durchsuchen...',
        newPatchNote: 'Neue Patch Note',
        noPatchNotesFound: 'Keine Patch Notes gefunden',
        searchTeamMembers: 'Teammitglieder durchsuchen...',
        addTeamMember: 'Teammitglied hinzufügen',
        noTeamMembersFound: 'Keine Teammitglieder gefunden',
        noEntriesIn: 'Keine Einträge in',
        found: 'gefunden',
        reportsOnSeparatePage: 'Reports werden auf einer separaten Seite verwaltet.',
        goToReports: 'Zu den Reports',
        entryCreated: 'Eintrag erstellt',
        entryUpdated: 'Eintrag aktualisiert',
        entryDeleted: 'Eintrag gelöscht',
        createError: 'Fehler beim Erstellen',
        updateError: 'Fehler beim Aktualisieren',
        deleteError: 'Fehler beim Löschen',
        patchNoteCreated: 'Patch Note erstellt',
        patchNoteUpdated: 'Patch Note aktualisiert',
        patchNoteDeleted: 'Patch Note gelöscht',
        teamMemberAdded: 'Teammitglied hinzugefügt',
        teamMemberUpdated: 'Teammitglied aktualisiert',
        teamMemberRemoved: 'Teammitglied entfernt',
        addError: 'Fehler beim Hinzufügen',
        removeError: 'Fehler beim Entfernen',
        loadError: 'Fehler beim Laden der Daten',
        
        // View Toggle
        gridView: 'Karten-Ansicht',
        listView: 'Listen-Ansicht',
        
        // Theme
        darkMode: 'Dunkel',
        lightMode: 'Hell',
        
        // Common
        search: 'Suchen...',
        all: 'Alle',
        filter: 'Filter',
        sort: 'Sortieren',
        noResults: 'Keine Ergebnisse',
        error: 'Fehler',
        success: 'Erfolg',
        administrator: 'Administrator',
        member: 'Mitglied',
        lockedForDev: 'In Entwicklung',
        pageBeingUpdated: 'Diese Seite wird gerade überarbeitet.',
        checkBackLater: 'Bitte schaue später wieder vorbei.',
        filterByRarity: 'Nach Seltenheit filtern',
        selectIslandLabel: 'Insel wählen',
        noIslandsYet: 'Noch keine Inseln vorhanden.',
        adminsCanCreateIslands: 'Admins können Inseln im Admin-Panel erstellen.',

	// Compare Modal
        compareTitle: 'Items vergleichen',
        compareCategory: 'Kategorie',
        compareSelected: 'ausgew�hlt',
        compareNoItems: 'Keine Items verf�gbar',
        compareProperty: 'Eigenschaft',
        compareRarity: 'Seltenheit',
        compareRank: 'Rang',
        compareAttributes: 'Attribute',
        compareNoFields: 'Keine Felder',
        compareNoData: 'Keine vergleichbaren Werte vorhanden',
        compareAction: 'Vergleichen',
        compareNew: 'Neuer Vergleich',
    
	// Codes Page
        codes: 'Codes',
        codesDescription: 'Einl�sbare Codes und ihre Belohnungen',
        codesSearch: 'Codes durchsuchen...',
        codesNone: 'Keine Codes vorhanden',
        codesCopy: 'Code kopieren',
        codesCopied: 'Kopiert!',
        codesNew: 'Neuer Code',
        codesEdit: 'Code bearbeiten',
        codesCode: 'Code',
        codesCodePlaceholder: 'z.B. RELEASE2026',
        codesReward: 'Belohnung',
        codesRewardPlaceholder: 'z.B. 500 Gems + 1x Epic Relic',
        codesDescriptionPlaceholder: 'Optionale zus�tzliche Beschreibung...',
        codesOptional: 'optional',
        codesActiveLabel: 'Aktiv',
        codesInactiveLabel: 'Inaktiv',
        codesInactive: 'Inaktiv',
        codesActivated: 'Code aktiviert',
        codesDeactivated: 'Code deaktiviert',
        codesActivate: 'Aktivieren',
        codesDeactivate: 'Deaktivieren',
        codesCreated: 'Code erstellt',
        codesUpdated: 'Code aktualisiert',
        codesDeleted: 'Code gel�scht',
        codesErrorNoCode: 'Bitte gib einen Code ein',
        codesErrorNoReward: 'Bitte gib eine Belohnung ein',
        adminDescCodes: 'Einl�sbare Codes verwalten',

    },
    en: {
        // Navigation
        dashboard: 'Dashboard',
        meta: 'Meta',
        relics: 'Relics',
        accessories: 'Accessories',
        skills: 'Skills',
        gachas: 'Gachas',
        upgrades: 'Upgrades',
        achievements: 'Achievements',
        tutorials: 'Tutorials',
        timers: 'Timers',
        admin: 'Admin',
        adminPanel: 'Admin Panel',
        reports: 'Reports',
        logout: 'Logout',
        
        // Dashboard
        yourProgress: 'Your personal progress and statistics',
        overallProgress: 'Overall Progress',
        progressDescription: 'Your collection progress across all categories',
        collected: 'collected',
        compareItems: 'Compare items',
        patchNotes: 'Patch Notes',
        ourTeam: 'Our Team',
        noPatchNotes: 'No patch notes available.',
        noTeamMembers: 'No team members available.',
        exportProgress: 'Export progress',
        
        // Timer Page
        eventSchedules: 'Event Schedules',
        eventSchedulesDescription: 'Respawn times and event countdowns (UTC)',
        nextEvent: 'Next Event',
        active: 'Active',
        startsIn: 'Starts in',
        endsIn: 'Ends in',
        monToThu: 'Monday to Thursday',
        friToSun: 'Friday to Sunday',
        everyDay: 'Every day',
        spawnRate: 'Spawn Rate',
        despawns: 'Despawns after',
        minutes: 'minutes',
        lasts: 'Lasts',
        inGameTime: 'in-game time',
        
        // Admin
        wikiContent: 'Wiki Content',
        islandSystem: 'Island System',
        management: 'Management',
        metaBuilds: 'Meta Builds',
        dataBackup: 'Data Backup',
        changeHistory: 'Change History',
        team: 'Team',
        searchEntries: 'Search entries...',
        newEntry: 'New Entry',
        lock: 'Lock',
        unlock: 'Unlock',
        loading: 'Loading...',
        noEntries: 'No entries found',
        noDescription: 'No description',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        create: 'Create',
        name: 'Name',
        description: 'Description',
        image: 'Image',
        rarity: 'Rarity',
        selectIsland: 'Select an island',
        newGacha: 'New Gacha',
        newUpgrade: 'New Upgrade',
        selectIslandToManage: 'Select an island to manage items',
        valuesPerRarity: 'Values per rarity',
        addField: 'Add field',
        fieldName: 'Field name',
        value: 'Value',
        noValues: 'No values defined',
        confirmDelete: 'Really delete?',
        deleteWarning: 'This action cannot be undone.',
        templates: 'Templates',
        useTemplate: 'Use template',
        saveAsTemplate: 'Save as template',
        duplicateWarning: 'An entry with a similar name already exists!',
        whitelist: 'Whitelist',
        
        // Lock Mode
        lockMode: 'Lock Mode',
        lockModeDescription: 'Lock individual sections of the site. Locked pages will be shown as "In Development".',
        locked: 'Locked',
        unlocked: 'Unlocked',
        lockStatusChanged: 'Lock status changed',
        lockError: 'Error changing lock status',
        
        // Admin descriptions
        adminDescRelics: 'Manage wiki entries for Relics',
        adminDescAccessories: 'Manage wiki entries for Accessories',
        adminDescSkills: 'Manage wiki entries for Skills',
        adminDescGachas: 'Select an island and manage its Gachas',
        adminDescUpgrades: 'Select an island and manage its Upgrades',
        adminDescAchievements: 'Manage achievements and rewards',
        adminDescTutorials: 'Manage tutorial entries',
        adminDescWhitelist: 'Manage Discord whitelist for login',
        adminDescMetaBuilds: 'Manage meta build recommendations',
        adminDescDataBackup: 'Export, import and restore data',
        adminDescChangeHistory: 'All admin actions with name and timestamp',
        adminDescPatchNotes: 'Manage patch notes and updates',
        adminDescTeam: 'Manage team members',
        adminDescReports: 'Review reported issues',
        adminDescLockMode: 'Lock individual sections of the website',
        searchPatchNotes: 'Search patch notes...',
        newPatchNote: 'New Patch Note',
        noPatchNotesFound: 'No patch notes found',
        searchTeamMembers: 'Search team members...',
        addTeamMember: 'Add team member',
        noTeamMembersFound: 'No team members found',
        noEntriesIn: 'No entries in',
        found: 'found',
        reportsOnSeparatePage: 'Reports are managed on a separate page.',
        goToReports: 'Go to Reports',
        entryCreated: 'Entry created',
        entryUpdated: 'Entry updated',
        entryDeleted: 'Entry deleted',
        createError: 'Error creating entry',
        updateError: 'Error updating entry',
        deleteError: 'Error deleting entry',
        patchNoteCreated: 'Patch note created',
        patchNoteUpdated: 'Patch note updated',
        patchNoteDeleted: 'Patch note deleted',
        teamMemberAdded: 'Team member added',
        teamMemberUpdated: 'Team member updated',
        teamMemberRemoved: 'Team member removed',
        addError: 'Error adding',
        removeError: 'Error removing',
        loadError: 'Error loading data',
        
        // View Toggle
        gridView: 'Grid View',
        listView: 'List View',
        
        // Theme
        darkMode: 'Dark',
        lightMode: 'Light',
        
        // Common
        search: 'Search...',
        all: 'All',
        filter: 'Filter',
        sort: 'Sort',
        noResults: 'No results',
        error: 'Error',
        success: 'Success',
        administrator: 'Administrator',
        member: 'Member',
        lockedForDev: 'In Development',
        pageBeingUpdated: 'This page is currently being updated.',
        checkBackLater: 'Please check back later.',
        filterByRarity: 'Filter by Rarity',
        selectIslandLabel: 'Select Island',
        noIslandsYet: 'No islands available yet.',
        adminsCanCreateIslands: 'Admins can create islands in the admin panel.',

	// Compare Modal
        compareTitle: 'Compare items',
        compareCategory: 'Category',
        compareSelected: 'selected',
        compareNoItems: 'No items available',
        compareProperty: 'Property',
        compareRarity: 'Rarity',
        compareRank: 'Rank',
        compareAttributes: 'Attributes',
        compareNoFields: 'No fields',
        compareNoData: 'No comparable values available',
        compareAction: 'Compare',
        compareNew: 'New comparison',
	
	// Codes Page
        codes: 'Codes',
        codesDescription: 'Redeemable codes and their rewards',
        codesSearch: 'Search codes...',
        codesNone: 'No codes available',
        codesCopy: 'Copy code',
        codesCopied: 'Copied!',
        codesNew: 'New Code',
        codesEdit: 'Edit Code',
        codesCode: 'Code',
        codesCodePlaceholder: 'e.g. RELEASE2026',
        codesReward: 'Reward',
        codesRewardPlaceholder: 'e.g. 500 Gems + 1x Epic Relic',
        codesDescriptionPlaceholder: 'Optional additional description...',
        codesOptional: 'optional',
        codesActiveLabel: 'Active',
        codesInactiveLabel: 'Inactive',
        codesInactive: 'Inactive',
        codesActivated: 'Code activated',
        codesDeactivated: 'Code deactivated',
        codesActivate: 'Activate',
        codesDeactivate: 'Deactivate',
        codesCreated: 'Code created',
        codesUpdated: 'Code updated',
        codesDeleted: 'Code deleted',
        codesErrorNoCode: 'Please enter a code',
        codesErrorNoReward: 'Please enter a reward',
        adminDescCodes: 'Manage redeemable codes',
    }
};

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem('wiki-language');
        return saved || 'en';
    });

    useEffect(() => {
        localStorage.setItem('wiki-language', language);
    }, [language]);

    const t = (key) => {
        return translations[language]?.[key] || translations.de[key] || key;
    };

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'de' ? 'en' : 'de');
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
